import * as React from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { isMobile, isDesktop } from 'react-device-detect';
import { setReplacementValue, setIsInEdit, setStartReplacementValue } from '../../../../actions/salesActions';
import { showBankingDetails } from '../../../../actions/modalActions';
import RequestCallBack from '../../../OnlineQuotation/PortablePossessions/RequestCallBack';
import { IReplacementValueCheck } from '../../../../interfaces/Sales/salesInterfaces';

class ReplacementValueCheck extends React.PureComponent<IReplacementValueCheck, any> {
    constructor(props: any) {
        super(props);
        this.state = {};
        this.cancelEdit = this.cancelEdit.bind(this);
        this.handleReplacementValue = this.handleReplacementValue.bind(this);
        this.handleUpdateRiskItem = this.handleUpdateRiskItem.bind(this);
    }

    cancelEdit() {
        this.props.setIsInEdit(false);
    }

    async handleReplacementValue(e: any) {

        var value = e.target.value.replace(this.props.profileState.currencySymbol, "").replaceAll(",", "");

        if (value.length !== 0) {

            await this.props.setReplacementValue(parseFloat(value));
            

            if (this.props.salesState.replacementValue !== "") {
                await this.props.checkReplacementValue();
            }
            await this.props.setItemDetails(this.props.id);
        }
    }

    async handleUpdateRiskItem(e: any) {

        if (this.props.salesState.replacementValue !== "") {
            await this.props.checkReplacementValue();
        }

        if (this.props.salesState.replacementCheckResult === 'ok') {
            await this.props.updateRiskItemToQuote();
            await this.props.setStartReplacementValue(parseFloat(this.props.salesState.replacementValue));
        }
    }

    async componentDidMount() {
        await this.props.checkReplacementValue();
    }

    public render() {
        let selectedItem = <div></div>;
        let filterItem = null;
        var premium = this.props.premium;
        if (this.props.premium) {
            premium = Number(this.props.premium).toFixed(2);
        }
        if (this.props.id) {
            selectedItem = <div key={this.props.id} id={this.state.id} className="box col-12 mt-2 mb-2">
                <div id="PolicyDetails">
                    <div className="row mb-lg-0 pt-3">
                        <div className="col-12">
                            <h2 className="carName mb-0">{this.props.description}</h2>
                            <p className="portable-heading mt-5px">{this.props.subDescription ? this.props.subDescription : "Portable possessions"}</p>
                            {this.props.cellPhoneNumber && this.props.cellPhoneNumber !== "" &&
                                <p className="portable-heading mt-5px">Phone no. <b>{this.props.cellPhoneNumber}</b></p>
                            }
                        </div>
                        <div className="col-12 col-lg-6">
                            <p className="portable-sub-heading mb-1px">Comprehensive cover (retail value)</p>
                            <p className="portable-premuim">{this.props.profileState.currencySymbol} {premium} pm</p>
                        </div>

                        <div className="col-12 col-lg-6 text-lg-right">
                            <p className="portable-sub-heading mb-1px">New total monthly premium</p>
                            <p className="portable-premuim">{this.props.profileState.currencySymbol} {this.props.totalPolicyPremium} pm</p>
                        </div>
                    </div>
                    <div className="row">
                        {this.props.salesState.isInEdit &&
                            <div className="col-12">
                                <hr className="portable-quote-hr" />
                                <h3 className="portable-replacement-heading mb-0px">Replacement value</h3>
                                <p className="portable-sub-heading mt-1px mb-15px">Tap on the text box to change your replacement value</p>
                                <div className="row noma">
                                    <div className={"col-lg-6 col-12 nopa mr-15px mobile-mr-0px" + (isMobile ? " unset-max-width" : "")} id="replacementValue">
                                        <NumberFormat className="replacement-input" id="ReplacementValueInputId" placeholder={this.props.profileState.currencySymbol} name="replacementValue" thousandSeparator={true} thousandsGroupStyle="thousand" prefix={this.props.profileState.currencySymbol} value={this.props.salesState.replacementValue} onChange={this.handleReplacementValue} />
                                        {this.props.salesState.replacementCheckResult && this.props.salesState.replacementCheckResult !== "ok" && this.props.salesState.replacementValue !== "" &&
                                            <p className="replacement-value-help-block mt-10px ml-20px mobile-ml-0px text-lg-left text-center mb-20px">The value can’t be {this.props.salesState.replacementCheckResult} than {this.props.profileState.currencySymbol}{this.props.salesState.replacementCheckResult === 'more' ? this.props.salesState.MaxReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "") : this.props.salesState.MinReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "")}</p>
                                        }
                                    </div>
                                    <div className={"col-lg-6 col-12 nopa mobile-mt-20px" + (isMobile ? " unset-max-width " : " portable-quote-button-holder")}>
                                    <button id="Update-replacement-value-btn" onClick={this.handleUpdateRiskItem} disabled={parseFloat(this.props.salesState.startReplacementValue) === parseFloat(this.props.salesState.replacementValue) || this.props.salesState.replacementCheckResult !== "ok"} className={"btn " + ((this.state.startReplacementValue === this.props.salesState.replacementValue || this.props.salesState.replacementCheckResult !== "ok") ? " btn-solid-green btn-portable-update-value" : "btn-solid-green btn-portable-update-value")}>
                                            Update value
                                        </button>
                                    </div>
                                </div>
                                {this.props.salesState.replacementCheckResult !== undefined && this.props.salesState.replacementCheckResult !== "ok" && this.props.salesState.replacementCheckResult !== "" && this.props.salesState.replacementValue !== "" && <div className={isMobile ? "mt-20px" : ""}> <RequestCallBack /> </div>}
                            </div>
                        }
                    </div>
                </div>
                <div id="DetailsDiv" className="pb-4"></div>
            </div>
        }

        return (
            <>
                <div className="mb-2">
                    {selectedItem}
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReplacementValueCheck);